import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {gql, useLazyQuery} from "@apollo/client/index";
import ContactsForm from "../../Customer/ContactsForm";
import Typography from "@material-ui/core/Typography/Typography";
import Alert from "@material-ui/lab/Alert/Alert";
import * as ReactGA from "react-ga";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginBottom: 20,
            border: '1px dotted #ccc',
            padding: 15,
        },
        header: {
            marginTop: 15
        },
        headerMobile: {
            marginBottom: 5
        },
        subHeader: {
            marginBottom: 5
        },
        subHeaderMobile: {
            marginBottom: 10
        }
    }
});

const SEND_REQUEST = gql`
  query($sn:String, $name:String, $email:String, $phone:String, $discount: Int) {
        contact(contactInput: {sn:$sn, name:$name, email:$email, phone:$phone, discount:$discount}) {
            message
            code
            bookPriceMinorUnits
            extraDiscountMinorUnits
        }
  }
`;


export default function BuyNow(props) {

    const classes = useStyles();
    const item = props.item;
    const isMobile = props.isMobile;

    const [sendRequest, { loading, error, data }] = useLazyQuery(
        SEND_REQUEST
    );

    const handleContactInformation = (values) => {
        sendRequest({variables: {...values, sn: item.sn, discount: 0}});

        ReactGA.event({
            category: 'User',
            action: 'buy_now_submit'
        });
    };

    return isMobile ? (
        <div className={classes.root}>
            <Typography variant={"h6"} className={classes.headerMobile}>
                Buy now for ${new Intl.NumberFormat().format(item.dealerPrice / 100)}.
            </Typography>
                {error ? <Alert severity="warning">{error.message}</Alert> : null }
                {data ? <Alert severity="success">Thank you! We will confirm availability and reach back to you as soon as
                    possible!</Alert> :
                <>
                    <Typography className={<classes className="subHeaderMobile"></classes>}>
                        How can we reach you?
                    </Typography>
                    < ContactsForm loading={loading} handleContactInformation={handleContactInformation}/>
                </>
            }
        </div>
    ) : <>
        <Typography variant={"h6"} className={classes.header}>
            Buy now for ${new Intl.NumberFormat().format(item.dealerPrice / 100)}.
            <Typography className={classes.subHeader}>
                Please, leave us your contact information.
            </Typography>
        </Typography>
        <div className={classes.root}>

        {error ? <Alert severity="warning">{error.message}</Alert> : null }
        {data ? <Alert severity="success">Thank you! We will confirm availability and reach back to you as soon as
                possible!</Alert> :
            <>
                <ContactsForm loading={loading} handleContactInformation={handleContactInformation}/>
            </>
        }
    </div></>;
}
